import React from 'react';
import {
    Button,
    Dialog,
    Flex,
    Label,
    pxToRem,
    useAppDisplayModeContext,
    useStyles,
    useTheme,
} from '@archipro-design/aria';
import ReturnsPolicyTemplate from './RefundTemplate';
import * as S from './RefundPolicy.style';
import { CloseLine } from '@archipro-design/icons';
import type { RefundPolicyData } from './RefundPolicy';
import RefundPolicyDialogMobile from './RefundPolicyDialog.mobile';

const RefundPolicyDialog = ({
    open,
    close,
    data,
}: {
    open: boolean;
    close: () => void;
    data: RefundPolicyData;
}) => {
    const { css } = useStyles();
    const theme = useTheme();
    const { mobile } = useAppDisplayModeContext();

    if (mobile) {
        return (
            <RefundPolicyDialogMobile open={open} close={close} data={data} />
        );
    }
    return (
        <Dialog
            open={open}
            onCancel={close}
            header={{
                content: (
                    <Flex
                        space="between"
                        vAlign="center"
                        wrap={false}
                        className={css(S.RefundHeader)}
                    >
                        <Label>Return and Refund policy</Label>
                        <Button
                            variables={{
                                buttonPadding: pxToRem(4),
                            }}
                            size={30}
                            variant="text"
                            icon={<CloseLine />}
                            onClick={close}
                        />
                    </Flex>
                ),
            }}
            content={{
                children: <ReturnsPolicyTemplate data={data} />,
            }}
            variables={{
                rootWidth: pxToRem(896),
                headerFontSize: theme.siteVariables.fontSizes.subheading02,
                headerMargin: pxToRem(0),
            }}
            className={css(S.RefundPolicyDialog)}
        />
    );
};

export default RefundPolicyDialog;
